<template>
  <div class="preloader__wrapper" :class="rootCss">
    <span class="preloader__elem"></span>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "large",
    },
  },
  computed: {
    rootCss() {
      return [`preloader__wrapper_${this.type}`];
    },
  },
};
</script>

<style scoped>
.preloader__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.preloader__wrapper_small {
  height: 25vh;
}

.preloader__wrapper_large {
  height: 50vh;
}

.preloader__elem {
  width: 5rem;
  height: 5rem;
  border-top-color: #337ab7;
  border-left-color: #337ab7;
  animation: preloader 400ms linear infinite;
  border-bottom-color: transparent;
  border-right-color: transparent;
  border-style: solid;
  border-width: 2px;
  border-radius: 50%;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: middle;
}

@keyframes preloader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/Preloader.vue